
export default {

        parseError(value, entityType) {

            if(!value) {
                return null;
            }

            if(value.response) {

                if(value.response.status == 401) {
                    //unauthorized
                    return {
                        message: 'Login required, your session is not valid or has expired. Please refresh the page and login to continue.'
                    }
                } else if(value.response.status == 403) {
                    //forbidden
                    if(entityType == 'dashboard') {
                        return {
                            message: "Permission denied, you don't have the required access to view this dashboard. Select a different organization or contact an Admin for your organization and check your user account has the required permissions."
                        }
                    }
                    else if(entityType == 'session') {
                        return {
                            message: "Permission denied, you don't have the required access to view this session. Select a different session or contact an Admin for your organization and check your user account has the required permissions."
                        }
                    }

                    return {
                        message: 'Permission denied, contact an Admin for your organization and check your user account has the required permissions.'
                    }
                } else if(value.response.status == 500) {
                    //server error
                    return {
                        message: 'An unexpected server error occurred.'
                    }
                } else if(value.response.status == 404) {
                    if(entityType == 'dashboard') {
                        return {
                            message: "The requested dashboard data could not be found."
                        }
                    }
                    else if(entityType == 'session') {
                        return {
                            message: "The requested session data could not be found."
                        }
                    }
                    else if(entityType == 'athlete') {
                        return {
                            message: "The requested athlete data could not be found."
                        }
                    }

                    return {
                        message: 'The requested item could not be found.'
                    }
                }

                return {
                    message: 'error code: ' + value.response.status + ' ' + value.response.statusText
                }

            } else if(value.isAxiosError) {
                return {
                    message: 'A network error occurred, Please check your internet connection.'
                }
            } else {
                return {
                    message: 'An unexpected error occurred.'
                }
            }
        }



}
